<app-page-header icon="manage_accounts" title="Modificar Usuario" subtitle="Edición de datos del usuario"></app-page-header>

<app-loading *ngIf="!flagLoaded || flagDisableButton" class="m-5"></app-loading>

<div *ngIf="flagLoaded" class="usuario-form-area seguridad-animate-in">
    <form [formGroup]="forma" (ngSubmit)="ngSubmit()" class="usuario-form">

        <div class="usuario-form__layout">
            <!-- ================= Columna izquierda: datos + estado ================= -->
            <div class="usuario-form__col">
                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">badge</span>
                        Datos del usuario
                    </div>
                    <div class="ds-section__body">
                        <div class="form-grid">
                            <div class="ds-field">
                                <label class="ds-field__label" for="nombrePersona">Nombre</label>
                                <input id="nombrePersona" class="ds-field__input" type="text"
                                    formControlName="nombrePersona" placeholder="Ingrese un nombre" autocomplete="off"
                                    [class.is-invalid]="nombrePersona" />
                                <span class="ds-field__hint" *ngIf="!puedeEditarIdentidad">
                                    Solo perfiles ADMIN / SYSADMIN pueden editar el nombre.
                                </span>
                            </div>

                            <div class="ds-field">
                                <label class="ds-field__label" for="apellidoPersona">Apellido</label>
                                <input id="apellidoPersona" class="ds-field__input" type="text"
                                    formControlName="apellidoPersona" placeholder="Ingrese un apellido"
                                    autocomplete="off" [class.is-invalid]="apellidoPersona" />
                            </div>

                            <div class="ds-field">
                                <label class="ds-field__label" for="nickname">Nickname</label>
                                <input id="nickname" class="ds-field__input" type="text" formControlName="nickname"
                                    placeholder="Ingrese el nickname" autocomplete="off"
                                    [class.is-invalid]="nickname" />
                            </div>

                            <div class="ds-field">
                                <label class="ds-field__label" for="email">Email</label>
                                <input id="email" class="ds-field__input" type="email" formControlName="email"
                                    placeholder="Ingrese un email" autocomplete="off" [class.is-invalid]="email" />
                                <span class="ds-field__hint">
                                    Si cambia el email, corrobore que sea correcto: todas las notificaciones se
                                    enviarán a esa cuenta.
                                </span>
                            </div>

                            <div class="ds-field">
                                <label class="ds-field__label" for="perfil">Perfil</label>
                                <div class="ds-field__control">
                                    <select id="perfil" class="ds-field__select" formControlName="perfil"
                                        [class.is-invalid]="perfil">
                                        <option value="" disabled>Seleccione un perfil</option>
                                        <option *ngFor="let p of selectPerfiles" [value]="p._id">
                                            {{ p.descripcion }}
                                        </option>
                                    </select>
                                    <span class="material-icons ds-field__caret">expand_more</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>

                <div class="ds-card">
                    <div class="ds-section__head">
                        <span class="material-icons">toggle_on</span>
                        Estado de la cuenta
                    </div>
                    <div class="ds-section__body">
                        <div class="toggles">
                            <label class="ds-switch">
                                <input type="checkbox" formControlName="estado" />
                                <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                                <span class="ds-switch__label">Suspendido</span>
                            </label>

                            <label class="ds-switch">
                                <input type="checkbox" formControlName="email_verified" />
                                <span class="ds-switch__track"><span class="ds-switch__thumb"></span></span>
                                <span class="ds-switch__label">Email verificado</span>
                            </label>
                        </div>

                        <div class="ds-alert ds-alert--info">
                            <span class="material-icons">info</span>
                            <div>
                                Al marcar <strong>Email verificado</strong>, el sistema considerará que el usuario
                                validó su cuenta y eliminará el PIN pendiente.
                            </div>
                        </div>
                    </div>
                </div>
            </div>

            <!-- ================= Columna derecha: sedes ================= -->
            <div class="usuario-form__col usuario-form__col--sedes">
                <div class="ds-card ds-card--fill">
                    <div class="ds-section__head">
                        <span class="material-icons">business</span>
                        Sedes
                    </div>
                    <div class="ds-section__body">
                        <div class="ds-alert ds-alert--warning" *ngIf="!desdeAfiliados">
                            <span class="material-icons">priority_high</span>
                            <div>
                                <strong>Importante:</strong> los AFILIADOS no pueden tener más de una sede.
                            </div>
                        </div>

                        <div class="chips-picker">
                            <div class="chips-picker__selected" *ngIf="sedesSeleccionadasData.length; else sinSedes">
                                <span class="chip-sede" *ngFor="let sede of sedesSeleccionadasData">
                                    {{ sede.nombre }}
                                    <button type="button" class="chip-sede__x" [disabled]="desdeAfiliados"
                                        (click)="quitarSede(sede._id)" aria-label="Quitar sede">
                                        <span class="material-icons">close</span>
                                    </button>
                                </span>
                            </div>
                            <ng-template #sinSedes>
                                <span class="chips-picker__empty">Ninguna sede seleccionada</span>
                            </ng-template>

                            <ng-container *ngIf="!desdeAfiliados">
                                <div class="chips-picker__search">
                                    <span class="material-icons">search</span>
                                    <input type="text" [(ngModel)]="sedeBusqueda"
                                        [ngModelOptions]="{ standalone: true }"
                                        placeholder="Buscar sede por nombre..." autocomplete="off" />
                                    <button type="button" class="chips-picker__toggle" (click)="toggleTodasSedes()">
                                        {{ todasSedesSeleccionadas ? 'Quitar todas' : 'Todas' }}
                                    </button>
                                </div>

                                <div class="chips-picker__list">
                                    <button type="button" class="opt" *ngFor="let sede of sedesFiltradas"
                                        [class.opt--on]="sedeEstaSeleccionada(sede._id)" (click)="toggleSede(sede)">
                                        <span class="material-icons opt__check">
                                            {{ sedeEstaSeleccionada(sede._id) ? 'check_box' : 'check_box_outline_blank' }}
                                        </span>
                                        <span class="opt__label">{{ sede.nombre }}</span>
                                    </button>
                                    <div class="chips-picker__empty" *ngIf="sedesFiltradas.length === 0">
                                        Sin resultados
                                    </div>
                                </div>
                            </ng-container>

                            <span class="ds-field__hint" *ngIf="sede">Seleccione al menos una sede</span>
                        </div>
                    </div>
                </div>
            </div>
        </div>

        <div class="acciones-form">
            <a *ngIf="!desdeAfiliados" routerLink="/usuarios-listado" class="ds-pill ds-pill--outline">Cancelar</a>
            <a *ngIf="desdeAfiliados" routerLink="/afiliados-listado" class="ds-pill ds-pill--outline">Cancelar</a>
            <button type="submit" class="ds-pill ds-pill--primary" [disabled]="!forma.valid || flagDisableButton">
                <span class="material-icons">save</span>
                Guardar
            </button>
        </div>
    </form>
</div>
